var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPositivePleased = function SvgPositivePleased(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 375 375"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".positive-pleased_svg__cls-2{fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:10;stroke-width:13.15px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "positive-pleased_svg__Graphic"
  }, /*#__PURE__*/React.createElement("path", {
    className: "positive-pleased_svg__cls-2",
    d: "M199.25 203.15a22 22 0 1143.91 0M130.84 203.15a22 22 0 1143.91 0M241.39 158a44.75 44.75 0 00-34.13-5.33M132.61 158a44.75 44.75 0 0134.13-5.33"
  }))));
};
export default SvgPositivePleased;